import React, { useState, useEffect } from "react";
import axios from "axios";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { donwloadCSV, videodownloadPDF, videodownloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { CiShare1 } from "react-icons/ci";
import { FaEllipsisVertical } from "react-icons/fa6";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { LiaUndoAltSolid } from "react-icons/lia";
import { BiRecycle } from "react-icons/bi";
import { RxReload } from "react-icons/rx";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminPublishType from "../../../components/CommonComponents/AdminPublishType";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { connect } from "react-redux";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import LiveAdBreakButton from "../../../components/LiveAdBreakButton";

function AllLiveStream({ siteTheme }) {
  const { fetchRequest, deleteImageFile } = useMyContext()
  const labelSource = 'live-stream'
  const headers = getItemToken('access_token')
  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/livestream`
  const bannerToggle = `${BaseUrl}/admin/livestream/slider-update`
  const multiDelete = `${BaseUrl}/admin/livestream/delete`
  const labelApi = `${BaseUrl}/admin/Label-Management/list-source?source=${labelSource}`
  const languageApi = `${BaseUrl}/admin/User-Translate-Language`
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10);
  const [draft, setDraft] = useState(0);
  const [deleteActionType, setDeleteActionType] = useState(2);
  const [total, setTotal] = useState('')
  const [type, setType] = useState(null)
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [languageCode, setLanguageCode] = useState('');
  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })
  useEffect(() => {
    const fetchLanguageCode = async () => {
      try {
        const { data } = await axios.get(languageApi, { headers });
        if (data?.status) {
          const language = data?.Language_Code || 'en';
          setLanguageCode(language);
        } else {
          console.warn('Unexpected API response format:', data);
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message || error.message || 'Unknown error';
        console.error('Error fetching language code:', errorMsg);
      }
    };
    fetchLanguageCode();
  }, []);

  const fetchData = async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: { type, page, 
        limit: formData?.title ? total?.count_all : limit,  
        search: formData?.title, 
        soft_delete: draft 
      },
      data: {},
    })
      .then(response => {
        const result = response;
        const updatedList = result?.data?.map((item) => {
          const UploadStatus = item?.uploaded_by_role;

          const statusText = item?.active === 1 && item?.publish_type === "publish_now" && item?.status === 1
            ? // &&
            // item?.draft === 1
            "PUBLISHED" : item?.active == null && item?.publish_type === "publish_later" && item?.status == null
              ? //  &&
              // item?.draft == null
              "SCHEDULED"
              : "DRAFT";

          return {
            ...item, uploaded_by_role: UploadStatus, active: statusText
          };
        });
        setApiData(updatedList);
        setPage(result?.pagination?.currentPage)
        setTotal(result?.pagination)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
      })
  };

  const fetchAllData = async (type, find) => {
    const data = await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        search: find === "ALL" ? null : formData?.title,
        type: null,
        page: 1,
        limit: find === "ALL" ? total?.count_all : total?.totalItems,
      },
      data: {},
    });

    let updatedList;

    if (find === "ALL") {
      updatedList = data?.data || [];
    } else {
      if (!itemToDelete || itemToDelete.length === 0) {
        alert("Please select at least one row to export.");
        return;
      }
      updatedList = data?.data?.filter(item => itemToDelete.includes(item?.id));
      if (!updatedList || updatedList.length === 0) {
        alert("Selected data not found.");
        return;
      }
    }

    const exportData = updatedList.map((item, index) => ({
      "S.NO": index + 1,
      "TITLE": item?.title,
      "DURATION": item?.duration,
      "UPLOADED BY ROLE": item?.uploaded_by_role,
      "LIVESTREAM STATUS": item?.current_status,
      "UPLOADED BY": item?.upload_on,
    }));

    if (type === "CSV") {
      await donwloadCSV(exportData, "LIVE-LIST");
    } else if (type === "PDF") {
      await videodownloadPDF(exportData, "LIVE-LIST", [
        "S.NO", "TITLE", "DURATION", "UPLOADED BY ROLE", "LIVESTREAM STATUS", "UPLOADED BY"
      ]);
    } else if (type === "XLSX") {
      await videodownloadXLSX(exportData, "LIVE-LIST", [
        "S.NO", "TITLE", "DURATION", "UPLOADED BY ROLE", "LIVESTREAM STATUS", "UPLOADED BY"
      ]);
    }
  };

  const handleDeleteImage = async () => {
    await deleteImageFile(itemToDelete, "LiveStream");
  }

  const handleConfirmDelete = async (actionType) => {
    setShowOverlay(true);
    await handleDeleteImage();
    await fetchRequest({
      method: 'DELETE',
      url: `${multiDelete}`,
      params: {},
      data: { id: itemToDelete, action: actionType || deleteActionType },
    })
      .then(response => {
        const result = response;
        if (result?.status) {
          setWithoutRefresh(!withOutRefresh);
          toast.success(result?.message);
          setItemToDelete([])
          setShowOverlay(false)
        }
      })
      .catch(error => {
        setShowOverlay(false)
        toast.error(error?.response?.data?.message);
      })
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleSizePerPageChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToDelete([]);
    setDeleteActionType(2)
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    if (draft === 1) {
      setDeleteActionType(3)
    }
  };
  const singlePeramanentDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id])
    setDeleteActionType(1)
  }
  const handleDeletedata = (actionType) => {
    handleConfirmDelete(actionType);
    closeModal();
  };

  const columns = [
    {
      dataField: "title",
      text: "Title",
      width: "30%",
      colStyle: "px-5",
      formatter: (cell, row) => {
        const baseUrl = process.env.REACT_APP_Baseurl_Frontend?.replace(/\/$/, '');
        const slug = row?.slug || row?.artist_slug;
        const title = row?.title || row?.albumname || row?.artist_name;
        const shouldTranslate = siteTheme?.translate_checkout === 1;
        const livePath = shouldTranslate
          ? `${baseUrl}/${languageCode}/live/${slug}`
          : `${baseUrl}/live/${slug}`;

        const imageUrl = row?.image_url || row?.Thumbnail || row?.image || row?.album;
        const displayTitle = title?.slice(0, 15) + '...';

        return (
          <div className="d-flex justify-content-between align-items-center">
            {imageUrl ? (
              <img
                key={imageUrl}
                src={imageUrl}
                alt={title}
                className="profile theme-bg-color-secondary"
              />
            ) : (
              <div className="profile theme-bg-color-secondary text-dark d-flex align-items-center justify-content-center admin-input-title">
                {title?.slice(0, 1).toUpperCase()}
              </div>
            )}

            <div className="rightVideoTitle ms-2">
              <Link
                className="theme-text-color table-heading d-flex align-items-center"
                target="_blank"
                to={livePath}
              >
                <span>{displayTitle}</span>
                {row?.active !== "DRAFT" && (
                  <CiShare1
                    style={{
                      width: "15px",
                      height: "15px",
                      strokeWidth: "1px",
                      marginLeft: "6px",
                    }}
                  />
                )}
              </Link>
              {row?.duration !== "0" && (
                <span className="me-1 dateText theme-text-color table-subheading">
                  {row?.duration}
                </span>
              )}
              <span className="dateText table-subheading theme-text-color">
                {row?.upload_on}
              </span>
            </div>
          </div>
        );
      },
      sort: true,
    },

    {
      dataField: "uploaded_by_role",
      text: "Upload by",
      sort: true,
      width: "20%",
      rowStyle: "px-4",
    },
    {
      dataField: "current_status",
      text: "Status",
      colStyle: "px-5",
      // formatter: (cell, row) => <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${cell === "PUBLISHED" ? "PUBLISHED_active" : cell === "SCHEDULED" ? " DISABLED_active" : "UNPUBLISHED_active"}`} > {cell} </div>
      formatter: (cell, row) => <AdminPublishType data={cell} publish_later_timing={row?.publish_later_timing} id={row?.id} active={row?.active} />

    },

    // {
    //   dataField: "banner",
    //   text: "Slider",
    //   formatter: (cell, row) => <AdminSwitch name="banner" checked={cell == 1} onChange={() => handleToggle(row)} id={row?.id} />
    // },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => {
        return <div className="editdropdown">
          <span className="editdropdown-button">
            <FaEllipsisVertical />
          </span>
          <div className="editdropdown-menu theme-bg-color">
            {draft !== 1 && (<Link to={`${"/edit-livestream/"}${row?.id}`} className="theme-text-color  theme-bg-color">
              <span className="theme-text-color">
                <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
              </span>
            </Link>)}
            {row?.status === 1 && (
              <div className="commonActionPadding theme-bg-color">
                <LiveAdBreakButton livestreamId={row?.id} />
              </div>
            )}
            <div onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color">
              {draft == 1 ? <LiaUndoAltSolid style={{ width: "20px", height: "20px" }} /> : <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />}
              <MessageBox text={`${draft == 1 ? "Undo" : "Delete"}`} classname='ms-2 theme-text-color'></MessageBox>
            </div>
            {draft == 1 && (<div onClick={() => singlePeramanentDelete(row?.id)} className="commonActionPadding theme-bg-color">
              <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Delete Permanent" classname='ms-2 theme-text-color'></MessageBox>
            </div>)}
          </div>
        </div >
      }
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
    sizePerPageList: [
      { text: '5', value: 5 },
      { text: '10', value: 10 },
      { text: 'All', value: total?.totalItems }
    ]
  };

  const selectRow = {
    selected: itemToDelete,
  };

  const handleRowSelect = (rowId) => {
    if (itemToDelete.includes(rowId)) {
      setItemToDelete(itemToDelete.filter((id) => id !== rowId));
    } else {
      setItemToDelete([...itemToDelete, rowId]);
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };

  const handleSelectAll = () => {
    if (itemToDelete.length === apiData.length) {
      setItemToDelete([]);
    } else {
      setItemToDelete(apiData.map((row) => row.id));
    }
  };
  const handleInput = (e) => {
    const { type, name, value, checked } = e.target
    if (type === "search") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }
  const reloadAction = () => {
    setDraft(0)
    setWithoutRefresh(prev => !prev)
  }
  const reCycleBin = () => {
    setDraft(prev => prev === 1 ? 0 : 1);
    setItemToDelete([]);
  };


  useEffect(() => {
    fetchData();
  }, [page, limit, formData?.title, withOutRefresh, draft]);

  useEffect(() => {
    if (draft === 0) {
      setDeleteActionType(2)
    }
    if (draft === 1) {
      setDeleteActionType(3)
    }
    if (draft === 1) {
      setDeleteActionType(1)
    }
  }, [draft])


  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const confirmToggle = async () => {
    setShowOverlay(true);
    setShowModal(false);
    try {
      const formData = {};
      const newStatus = currentItem?.banner === 1 ? 0 : 1;
      formData['live_id'] = currentItem?.id;
      formData['banner_status'] = newStatus
      const response = await axios.post(`${bannerToggle}`, formData, { headers: headers });
      const result = response.data
      if (result.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setCurrentItem(null);
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };


  // Api links end 

  const handleToggle = async (item) => {
    setCurrentItem(item);
    setShowModal(true);
  };

  useEffect(async () => {
    await labelFetch()
  }, []);

  return (
    <>
      <div className="">
        {/* {showOverlay && <Response_Processing />} */}
        {modelClose && <AdminDeleteModal messageClassName={deleteActionType === 1 ? "warningColor" : ""} headingText={deleteActionType == 3 ? "Confirm Undo" : deleteActionType == 1 ? "Confirm Permanent Delete" : "Confirm Delete"} message={deleteActionType == 2 ? "Are you sure you want to delete" : deleteActionType == 3 ? "Are you sure you want to Undo item" : deleteActionType == 1 ? "Warning: This action will permanently delete the selected items from the server. Once deleted, the data cannot be recovered. Are you sure you want to proceed?" : "Are you sure you want to Delete"} modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={"custom"} actionText={deleteActionType == 1 ? "Delete Permanent" : deleteActionType == 2 ? "Delete" : deleteActionType == 3 ? "Undo" : ""} />}
        {showModal && <AdminSliderModal modelClose={showModal} sliderClose={closeModal} sliderAction={confirmToggle} buttonText={currentItem?.banner} />}
        <AdminNavbar heading={"All Live Streams"} totalDataLength={total?.totalItems} deleteCount={0} navigation={"/add-livestream"} deleteMethod={openModal} navText={labelDisplay?.[1]?.title} />
        <div className="theme-bg-color p-3 rounded-2 bootstrapTable  multi-delete-width" >
          <div className='theme-bg-color p-3 rounded-3 mb-5'>
            <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
              <input type='search' id="live-search-input" placeholder='Search' name="title" className='rounded-3 col-3  theme-border-color border-solid-width border-solid table-search  theme-bg-color-secondary' onChange={handleInput} />
              <div className='d-flex align-items-center justify-content-end'>
                {(draft !== 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete" className={"warningColorBg me-2"} saveMethod={() => { setModelClose(true); setDeleteActionType(2) }} /> : ""}
                {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Undo" className={"mx-3"} saveMethod={() => { setModelClose(true); setDeleteActionType(3) }} /> : ""}
                {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete Permanent" className={"me-3"} saveMethod={() => { setModelClose(true); setDeleteActionType(1) }} /> : ""}
                <button id="live-recycleButton" className={`custom-tool-tip-parent reloadButton p-2 me-2  border border-2 rounded-circle theme-border-color ${draft ? "button-bg-color theme-button-text-color" : " bg-transparent theme-text-color"}`} onClick={reCycleBin}>
                  <BiRecycle style={{ width: "18px", height: "15px" }} />
                  <AdminTooltip text="Recycle Bin" top={"-41px"} className="d-none custom-tool-tip" />

                </button>
                <button id="live-reloadButton" className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color }`} onClick={reloadAction}>
                  <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                  <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />

                </button>
                <div className="dropdown d-block ms-2 " key={"2"}>
                  <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="dropdownMenuButton1 live-exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                    <span className="fw-bolder text-white">Export</span>
                    <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                  </button>
                  <ul className="dropdown-menu theme-bg-color" aria-labelledby="dropdownMenuButton1" >
                    <li id="live-exportCSV" className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV")}>CSV</li>
                    <li id="live-exportPDF" className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF")}>PDF</li>
                    <li id="live-exportXLSX" className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX")}>XLSX </li>
                  </ul>
                </div>
                <div className="dropdown d-block ms-2 " key={"2"}>
                  <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="dropdownMenuButton1 live-exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                    <span className="fw-bolder text-white">Export all</span>
                    <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                  </button>
                  <ul className="dropdown-menu theme-bg-color" aria-labelledby="dropdownMenuButton1" >
                    <li id="exportallCSV" className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                    <li id="exportallPDF" className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                    <li id="exportallXLSX" className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
                  </ul>
                </div>
              </div>
            </div>

            <AdminTable data={apiData}
              loading={loading}
              options={options}
              handlePageChange={handlePageChange}
              page={page}
              pagination={total}
              handleSizePerPageChange={handleSizePerPageChange}
              columns={columns}
              limit={limit}
              selectRow={selectRow}
              multiSelect
              onRowSelect={handleRowSelect}
              onSort={handleSort}
              onSelectAll={handleSelectAll}
              viewType={formData?.view_type}
            />
          </div >
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  siteTheme: state.siteTheme.siteTheme
});

export default connect(mapStateToProps)(AllLiveStream)
